module.exports = __webpack_public_path__ + "img/prohibited_emoji.8da965c0.webp";